var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description-list-item"},[_c('div',{staticClass:"description-list-item-term"},[_vm._v(_vm._s(_vm.term))]),_c('div',{staticClass:"description-list-item-content",style:(_vm.contentStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }